import { createSelector } from 'reselect'
import { RootState } from '../../types/rootState'

export const selectClientTeamMemberships = (state: RootState) => state.clientTeamMemberships

export const selectUnverifiedMembership = createSelector(
  selectClientTeamMemberships,
  memberships => memberships?.data?.find(membership => !membership.isVerified) || null
)

export const selectVerifiedClientTeamMemberships = createSelector(
  selectClientTeamMemberships,
  memberships => memberships?.data?.filter(membership => membership.isVerified) || []
)

export const selectClientHasUnverifiedAgent = createSelector(selectUnverifiedMembership, unverifiedMembership => {
  return unverifiedMembership !== null
})

export const selectPreferredLoanOfficerMembership = createSelector(
  selectClientTeamMemberships,
  memberships => memberships?.data?.find(membership => membership.customerProfile.type === 'LoanOfficer') || null
)

export const selectPreferredRealEstateAgentMembership = createSelector(
  selectClientTeamMemberships,
  memberships => memberships?.data?.find(membership => membership.customerProfile.type === 'RealEstateAgent') || null
)

export const selectPreferredInsuranceAgentMembership = createSelector(
  selectClientTeamMemberships,
  memberships => memberships?.data?.find(membership => membership.customerProfile.type === 'InsuranceAgent') || null
)

export const selectPreferredRealEstateAgentMembershipWithLoading = createSelector(
  selectClientTeamMemberships,
  memberships => ({
    data: memberships?.data?.find(membership => membership.customerProfile.type === 'RealEstateAgent') || null,
    loading: memberships?.loading ?? false
  })
)

export const selectPreferredInsuranceAgentMembershipWithLoading = createSelector(
  selectClientTeamMemberships,
  memberships => ({
    data: memberships?.data?.find(membership => membership.customerProfile.type === 'InsuranceAgent') || null,
    loading: memberships?.loading ?? false
  })
)
